<div class="container">
     <div class="section-title">{{dataGroups.title}}</div>
     <div class="about-container">
          @for (aboutGroup of dataGroups.aboutMenuGroups; track $index) {
          @for (aboutMenu of aboutGroup.groupsItems; track $index; let last = $last) {
          <div class="about-menu-row" (click)="onCellPress(aboutMenu.disabled ? '' : aboutMenu.path)">
               <div class="about-menu-row-half">
                    @if (aboutMenu.icon) {
                         @if (aboutMenu.disabled) {
                         <div class="about-row-icon" [style]="{'background': 'var(--text-tertairy)'}">
                              <i [class]="aboutMenu.icon"></i>
                              </div>
                         }
                         @else {
                              <div class="about-row-icon" [style]="aboutMenu.iconColor">
                                   <i [class]="aboutMenu.icon"></i>
                              </div>
                         }
                    }
                    @if (aboutMenu.disabled) {
                         <div class="about-label" [style]="{'color': 'var(--text-tertairy)'}">{{ aboutMenu.name }}</div>
                    }
                    @else {
                         <div class="about-label">{{ aboutMenu.name }}</div>
                    }
               </div>
               <div class="about-menu-row-half">
                    @if (aboutMenu.name === 'Version Details') {
                    @if (versionBadgeValue != "0") {
                    <p-badge [value]="versionBadgeValue" severity="danger"></p-badge>
                    }}
                    <div class="static-about-text">
                         {{ aboutMenu.value }}
                    </div>
                    <i class="clickable-row pi pi-chevron-right"></i>
               </div>
          </div>
          @if (!last) {
          <div class="h-divider"></div>
          }}}
     </div>
</div>